import React, { Component } from 'react';
import { connect } from 'react-redux';
import FulltextSearchComponent from '../components/FulltextSearch';
import { setFulltextThemenSearch } from "../actions/referenten/filters";

class FulltextSearch extends Component
{
    render() {
        return <div>
            <FulltextSearchComponent fulltextLabel={'Themen Volltext Suche'} placeholderText={'Beispiel: "Kräuterwanderung"'} fulltextSubmit={this.fulltextSubmit.bind(this)}/>
        </div>
    }

    fulltextSubmit(phrase) {
        this.props.dispatch(setFulltextThemenSearch(phrase));
    }
}

export default connect()(FulltextSearch)



// WEBPACK FOOTER //
// ./src/containers/ThemenFulltextSearch.js